/* ---------------- UI atoms ---------------- */
import React from "react";
import {
  safe,
  asList,
  formatAddress,
  formatUKPhone,
  initialsFrom,
  cssColor,
  fmtMaybeDate,
  fmtMaybeMonthYear,
  statusColor,
  QUAL_GROUPS,
  pickTruthy,
} from "../../Utils/AdviserFormatters";

function Chip({ children, className = "", style, ...rest }) {
  return (
    <span
      className={`smChip Content-Small ${className}`}
      style={style}
      {...rest}
    >
      {children}
    </span>
  );
}

function PostCard({ title, children, right }) {
  return (
    <div className="smPost">
      <div className="smPostHeader">
        <div className="FP_Body_Semibold primary">{title}</div>
        {right ? <div className="smPostRight">{right}</div> : null}
      </div>
      <div className="smPostBody">{children}</div>
    </div>
  );
}

function Row({ label, value, kind, href }) {
  let out = value;

  if (kind === "date") out = fmtMaybeDate(value);
  if (kind === "monthYear") out = fmtMaybeMonthYear(value);

  if (Array.isArray(out)) out = out.filter(Boolean).join(", ");
  if (out && typeof out === "object") out = "-";

  return (
    <div className="smRow">
      <div className="smRowLabel FP_Body text-grey">{label}</div>
      <div className="smRowValue FP_Body text-black">
        {href ? <a href={href} rel="noopener noreferrer">{safe(out)}</a> : safe(out)}
      </div>
    </div>
  );
}

export { Chip, PostCard, Row };
